import Principal from '../screens/Index.vue'
import Video from '../screens/Video.vue'
export const routes = [     
    {path:'/tv',name:'home', component: Principal},
    {path:'/tv/:idTv/:categoria',name:'video', component: Video}       
];